<template>
  <div class="grasp-loader-wrapper" :style="{ 'animation-delay': delay ? delay+'s': '0.2s'}">
    <div v-show="loading" class="lds-ellipsis" :style="styles" :class="classes"><div></div><div></div><div></div><div></div></div>
  </div>
</template>
<script>
import {computed} from "@vue/reactivity";

export default {
  props: {
    size: String,
    color: String,
    loading: Boolean,
    delay: Number,
  },
  setup(props) {

    const styles = computed(() => {
      if(props.color) return 'color: '+props.color
      return ''
    })

    const classes = computed(() => {
      let classList = []

      if(props.size === 'is-large') {
        classList.push('spinner--is-large')
      } else if(props.size === 'is-small') {
        classList.push('spinner--is-small')
      } else {
        classList.push('spinner--is-medium')
      }
      return classList.join(' ')
    })

    return {
      classes,styles
    };
  },
};
</script>
<style lang="scss">

.grasp-loader-wrapper {
  opacity: 0;
  text-align: center;
  animation: fadeInSpinner 0.4s normal forwards;
  //animation-delay: 0.5s;

  .spinner--is-small {
    zoom: 0.25;
  }

  .spinner--is-medium {
    zoom: 0.5;
  }
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: currentColor;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

@keyframes fadeInSpinner {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
